import { render, staticRenderFns } from "./stackedBarChart.vue?vue&type=template&id=8a6946d8&"
import script from "./stackedBarChart.vue?vue&type=script&lang=js&"
export * from "./stackedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports